import * as actions from 'redux/actions/domainsList.actions'
import * as userActions from 'redux/actions/user.actions'
import * as accountActions from 'redux/actions/account.actions'
import * as domainsDataActions from 'redux/actions/domainsData.actions'
import * as keywordGrossingActions from 'redux/actions/keywordGrossing.actions'
import * as keywordDiscoveryActions from 'redux/actions/keywordDiscovery.actions'
import * as keywordSavingsOverviewActions from 'redux/actions/keywordSavingsOverview.actions'
import { sortData } from 'helpers/sortData'

import updateDomain from './domainsDataHelpers/updateDomainsListItem'

const initialState = {
  hasBeenLoaded: false,
  detailsHasBeenLoaded: false,
  chartsHasBeenLoaded: false,
  dataLoadedAt: null,
  domains: []
}

const domainsListReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.loadDomainsSuccess.type:
      return {
        ...state,
        hasBeenLoaded: true,
        dataLoadedAt: new Date(),
        domains: payload.domains
      }
    case actions.loadDomainsFully.type:
      return {
        ...state,
        hasBeenLoaded: false,
        detailsHasBeenLoaded: false,
        chartsHasBeenLoaded: false
      }
    case actions.loadDomainsFullySuccess.type:
      return {
        ...state,
        hasBeenLoaded: true,
        detailsHasBeenLoaded: true,
        chartsHasBeenLoaded: true,
        dataLoadedAt: new Date(),
        domains: payload.domains.sort(sortData(['attributes', 'trackedKeywords'], 'descending'))
      }
    case actions.sortDomains.type: {
      const value = payload.value
      const order = payload.order
      switch (true) {
        case value === 'Keywords':
          state.domains.sort(sortData(['attributes', 'trackedKeywords'], order, value))
          break
        case value === 'A-Z':
          state.domains.sort(sortData(['attributes', 'host'], order, value))
          break
        case value === 'Visibility':
          state.domains.sort(sortData(['attributes', 'visibility'], order, value))
          break
        case value === 'Avg. Position':
          state.domains.sort(sortData(['attributes', 'averageRank'], order, value))
          break
        case value === 'Traffic':
          state.domains.sort(sortData(['attributes', 'traffic'], order, value))
          break
        case value === 'SERP Feature':
          state.domains.sort(sortData(['attributes', 'positions', 'up'], order, value))
          break
        default:
          return state.domains
      }
      return {
        ...state,
        domains: state.domains
      }
    }
    case actions.loadDomainOverviewSuccess.type:
    case domainsDataActions.loadDomainSuccess.type:
    case domainsDataActions.loadCompetitorsSuccess.type:
    case domainsDataActions.loadDomainTagsSuccess.type:
    case domainsDataActions.loadKeywordsSuccess.type:
    case keywordGrossingActions.getDomainKeywordGrossingSuccess.type:
    case keywordDiscoveryActions.getDomainKeywordDiscoverySuccess.type:
    case keywordSavingsOverviewActions.getDomainKeywordSavingsOverviewSuccess.type: {
      let existingDomain = null
      // Similar reducer as on domainsData but for domainsList. Both reducers solves different problems.
      // Trick to avoid mutating the array - could be an issue if order ever mattered
      const existingDomains = JSON.parse(JSON.stringify(state.domains))
      if (existingDomains.length > 0) {
        existingDomain = existingDomains.find(domain => domain && domain.id === payload.id)
      }
      if (!existingDomain) {
        existingDomains.push(updateDomain({}, { type, payload }))
      }
      const updatedDomains = existingDomains.map(domain => {
        if (domain && domain.id === payload.id) {
          return updateDomain(domain, { type, payload })
        }

        return domain
      })
      return {
        ...state,
        domains: updatedDomains
      }
    }
    case actions.deleteDomainSuccess.type:
      return {
        ...state,
        domains: state.domains.filter(domain => domain.id !== payload.domainId)
      }
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return initialState
    default:
      return state
  }
}

export default domainsListReducer
